import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {partnerRegister } from "../../utilities/partnerServices";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
export const registerApi = createAsyncThunk(
  "users/registerApi",
  partnerRegister
);
const initialState = {
  registerData:{
    registrationsucces:false,
    privacyPolicycheckbox:false,
    loader: false,
   }
};
const registerSlice = createSlice({
  name: "registrations",
  initialState,
  reducers: {
    resetregsuccess:(state)=>{
      state.registerData.registrationsucces= false;
    },
    resetprivacyPolicycheckbox :(state, action) =>{
          state.registerData.privacyPolicycheckbox=false
    },
    privacyPolicycheckboxflag:(state,action)=>{
        state.registerData.privacyPolicycheckbox=action.payload
    }

  },
  extraReducers: (builder) => {
    builder
      .addCase(registerApi.pending, (state, action) => {
        state.registerData.loader = true;
      })
      .addCase(registerApi.fulfilled, (state, action) => {
        let data=action.payload
        if(data.ResponseDetails.ResponseCode == "010"){
          state.registerData.registrationsucces=true
          state.registerData.loader = false;
        }else{
          toast.error(data.ResponseDetails.ResponseMessage);
          state.registerData.loader = false;
        }
      })
      .addCase(registerApi.rejected, (state, action) => {
        toast.error(action.error.message);
        state.registerData.loader = false;
      });
  },
});
export const { resetregsuccess,privacyPolicycheckboxflag,resetprivacyPolicycheckbox } = registerSlice.actions
export default registerSlice.reducer;
